import React from "react"
import DataTableInfo from './DataTable'
import Modal from '../Modal'
import useSWR from 'swr'
import { useProject } from "../../context/project"

export default function ContainerDataTable({ dataset, open, handleClose, ticker }) {
    const { privateCompany } = useProject()
    const { data: dataTable } = useSWR(dataset?.datasetValue && `/api/getTableData?dataset=${dataset.datasetValue}&ticker=${ticker}&column=${encodeURIComponent(dataset.columnValue)}&private=${privateCompany}`)
    const { data: datasetInfo } = useSWR(dataset?.datasetValue && `/api/getDatasetsInfo?datasets=${dataset.datasetValue}&ticker=${ticker}`)

    return (
        <Modal open={open} handleClose={handleClose} title="Data Information">
            <DataTableInfo datasetInfo={datasetInfo} dataTable={dataTable} dataset={dataset}/>
        </Modal>
    ) 
}
